import React, { FC, ReactNode, useState } from "react";
import VerticalCaret from "./verticalCaret";

interface CollapsibleSectionProps {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
  className?: string;
}

const CollapsibleSection: FC<CollapsibleSectionProps> = ({
  title,
  children,
  defaultExpanded = false,
  className,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div
      className={className}
      style={{
        backgroundColor: "#f8f9fa",
        borderRadius: "10px",
        padding: "28px",
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ cursor: "pointer", marginBottom: expanded ? "16px" : 0 }}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? (
          <h6
            style={{
              color: "#666",
              fontWeight: 500,
              margin: 0,
              fontSize: "13px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            {title}
          </h6>
        ) : (
          <h4 className="fwt mb-0 f-5">{title}</h4>
        )}
        <VerticalCaret collapsed={!expanded} />
      </div>
      {expanded && children}
    </div>
  );
};

export default CollapsibleSection;
